// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, Navigation, Thumbs } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

const swiperThumbs = new Swiper( '.swiper-thumbs', {
	spaceBetween: 10,
	slidesPerView: 2,
	freeMode: true,
	watchSlidesProgress: true,
	breakpoints: {
		768: {
			slidesPerView: 4,
		},
	},
} );

// eslint-disable-next-line no-unused-vars
const swiperFull = new Swiper( '.swiper-full', {
	autoplay: { delay: 3500, disableOnInteraction: true },
	modules: [ Navigation, Autoplay, Thumbs ],
	slidesPerView: 1.25,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	spaceBetween: 16,
	breakpoints: {
		768: {
			slidesPerView: 1,
		},
	},
	thumbs: {
		swiper: swiperThumbs,
	},
} );
